import React from 'react';
import { Group, NumberInput, Select, Stack } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useTranslation } from 'react-i18next';
import { ConfigFormValues, operatorOptions } from './alertConfigurationConstants.ts';
import TrendFields from './TrendFields.tsx';

interface Props {
    form: UseFormReturnType<ConfigFormValues>;
    categoryOptions: { value: string; label: string }[];
    evaluationMode: string;
}

const QuestionnaireConditionFields: React.FC<Props> = ({ form, categoryOptions, evaluationMode }) => {
    const { t } = useTranslation();
    const isTrend = evaluationMode === 'trend';
    const needsPercentageOption = form.values.conditionTrendType === 'INCREASE' || form.values.conditionTrendType === 'DECREASE';

    if (evaluationMode === 'trend') 
        return <TrendFields form={form} categoryOptions={categoryOptions} />;

    return (
        <Stack gap="xs">
            <Select
                label={t('alertRule.form.category')}
                placeholder={t('alertRule.form.categoryPlaceholder')}
                data={categoryOptions}
                searchable
                {...form.getInputProps('conditionCategory')}
            />
            <Group grow align="flex-start">
                <Select
                    label={t('alertRule.form.operator')}
                    data={operatorOptions}
                    {...form.getInputProps('conditionOperator')}
                />
                <NumberInput
                    label={t('alertRule.form.value')}
                    placeholder="0"
                    decimalScale={2}
                    {...form.getInputProps('conditionThreshold')}
                />
            </Group>
        </Stack>
    );
};

export default QuestionnaireConditionFields;
